(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bar-chart-comparison"] && !Shopify.designMode) return;
  try {
    
/* Fuji Comparison Bars — reveal once, then get out of the way. */
(function () {
  var SELECTOR = '.fh-bars[data-fh-bars]';

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var nodes = root.querySelectorAll(SELECTOR);

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.dataset.fhReady) continue;
      el.dataset.fhReady = '1';

      if (
        !('IntersectionObserver' in window) ||
        (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)
      ) {
        el.classList.add('is-drawn');
        continue;
      }

      (function (node) {
        var io = new IntersectionObserver(
          function (entries, observer) {
            for (var j = 0; j < entries.length; j++) {
              if (entries[j].isIntersecting) {
                node.classList.add('is-drawn');
                observer.disconnect();
                return;
              }
            }
          },
          { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
        );
        io.observe(node);
      })(el);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-with-image-blur"] && !Shopify.designMode) return;
  try {
    
/* Fuji Underline Hero — one observer per hero, disconnected on first hit. */
(function () {
  var SELECTOR = '.fh-hero[data-fh-animate]';

  function reveal(el) {
    el.classList.add('is-drawn');
  }

  // A marked phrase wider than its column would be clipped by the hero's
  // overflow:hidden. Fall back to a wrapping native underline instead.
  // One read per hero, batched: no interleaved read/write, no thrash.
  function fit(el) {
    var mark = el.querySelector('.fh-hero__mark');
    var col = el.querySelector('.fh-hero__content');
    if (!mark || !col) return;

    // Measure the phrase itself with a Range. offsetWidth is capped by
    // max-width and scrollWidth is inflated by the absolutely positioned
    // stroke, so neither reports the text's true laid-out width.
    var text = null;
    for (var n = mark.firstChild; n; n = n.nextSibling) {
      if (n.nodeType === 3 && n.nodeValue.trim()) { text = n; break; }
    }
    if (!text) return;

    mark.classList.remove('is-tight');
    var range = document.createRange();
    range.selectNode(text);
    var wide = range.getBoundingClientRect().width > col.clientWidth;
    range.detach && range.detach();
    if (wide) mark.classList.add('is-tight');
  }

  var fitTimer;
  function fitAll() {
    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) fit(nodes[i]);
  }
  window.addEventListener('resize', function () {
    clearTimeout(fitTimer);
    fitTimer = setTimeout(fitAll, 150);
  }, { passive: true });

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var nodes = root.querySelectorAll(SELECTOR);

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.dataset.fhReady) continue;
      el.dataset.fhReady = '1';
      fit(el);

      // No observer support, or the visitor asked for less motion:
      // jump straight to the finished state.
      if (
        !('IntersectionObserver' in window) ||
        (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)
      ) {
        reveal(el);
        continue;
      }

      (function (node) {
        var io = new IntersectionObserver(
          function (entries, observer) {
            for (var j = 0; j < entries.length; j++) {
              if (entries[j].isIntersecting) {
                reveal(node);
                observer.disconnect();
                return;
              }
            }
          },
          { threshold: 0.25, rootMargin: '0px 0px -10% 0px' }
        );
        io.observe(node);
      })(el);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Theme editor: re-run for a section that was just re-rendered.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stat-carousel"] && !Shopify.designMode) return;
  try {
    
/* Fuji Stat Carousel — the browser scrolls; this only wires the buttons. */
(function () {
  var SELECTOR = '.fh-stats[data-fh-stats]';

  function setup(section) {
    var viewport = section.querySelector('.fh-stats__viewport');
    var track = section.querySelector('[data-fh-track]');
    var prev = section.querySelector('[data-fh-prev]');
    var next = section.querySelector('[data-fh-next]');
    if (!viewport || !track || !prev || !next) return;

    var ticking = false;

    function step() {
      var card = track.querySelector('.fh-stat');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function sync() {
      ticking = false;
      // 2px absorbs sub-pixel rounding at fractional zoom levels.
      var scrollable = track.scrollWidth - track.clientWidth > 2;
      viewport.classList.toggle('is-static', !scrollable);
      prev.hidden = next.hidden = !scrollable;
      if (!scrollable) return;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }

    function queue() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(sync);
    }

    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', queue, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(queue).observe(track);
    } else {
      window.addEventListener('resize', queue, { passive: true });
    }

    sync();
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var nodes = root.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].dataset.fhReady) continue;
      nodes[i].dataset.fhReady = '1';
      setup(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
